import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import ArticlePriceTable from '@accounting/components/tables/article-price-table/article-price-table.vue';

@Component({
  name: 'bpc-article-prices',
  components: {
    'bpc-article-price-table': ArticlePriceTable,
  },
})
export default class ArticlePriceTags extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
